import _extends from "@babel/runtime/helpers/extends";
import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";

function slugify(text) {
  return text.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "-").replace(/-+/g, "-");
}

export const NavItem = ({
  item,
  isOpen,
  className,
  containerClassName,
  onClick,
  linkComponent
}) => {
  const id = `nav-item-${slugify(item.text)}`;
  const canOpen = typeof isOpen !== "undefined" && isOpen !== null && item.children && item.children.length;
  const Link = canOpen ? item.linkComponent || "label" : item.linkComponent || linkComponent || "a";
  const svgExpandClasses = classnames(["-mr-1 ml-2 h-6 w-6 float-right xl:float-none nav-item-toggle"], {// "transform rotate-180 hidden xl:block": isOpen === true
  });
  const svgLineClasses = classnames(["mt-3 ml-3 w-4 float-right xl:float-none nav-item-line"], {
    hidden: isOpen !== true,
    "inline-block xl:hidden": isOpen === true
  });
  const containerClasses = classnames(["ml-0 xl:w-64 xl:ml-0 xl:left-0 xl:w-56 z-10", "origin-top-right relative xl:absolute right-0 mt-0 xl:mt-2 w-full rounded-md xl:shadow-lg nav-item-child"], containerClassName);

  const keyPressHandler = e => {
    if ([13, 32].includes(e.which)) {
      if (typeof onClick === "function") {
        onClick(e);
      }
    }
  };

  const navItemClasses = classnames(["mr-0 xl:mr-3 relative nav-item", className]);
  return /*#__PURE__*/React.createElement("li", {
    className: navItemClasses
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    name: "nav-item-check",
    type: "checkbox",
    className: "hidden nav-item-check",
    onChange: onClick
  }), /*#__PURE__*/React.createElement(Link, _extends({
    role: "button",
    className: "py-2 px-4 no-underline block xl:inline-flex cursor-pointer nav-item-button w-full text-left",
    href: item.href,
    to: item.href,
    htmlFor: id,
    tabIndex: "0",
    onKeyPress: keyPressHandler
  }, item), item.text, canOpen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    className: svgExpandClasses,
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("svg", {
    className: svgLineClasses,
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "2",
    viewBox: "0 0 12 2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: "16",
    transform: "translate(0 1)",
    fill: "none",
    stroke: "#2e3030",
    strokeWidth: "2"
  }))) : null), canOpen ? /*#__PURE__*/React.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-md bg-white xl:shadow-xs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-1 mt-3 ml-2 xl:ml-0 xl:mt-0",
    role: "menu",
    "aria-orientation": "vertical",
    "aria-labelledby": "options-menu"
  }, /*#__PURE__*/React.createElement("ul", null, item.children.map(child => /*#__PURE__*/React.createElement(NavItem, {
    item: child,
    key: child.text,
    className: "text-md text-gray-600 xl:text-gray-700",
    linkComponent: child.linkComponent || linkComponent
  })))))) : null);
};
NavItem.propTypes = {
  item: PropTypes.shape({
    href: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string
    })),
    text: PropTypes.string.isRequired,
    linkComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType])
  }).isRequired,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  containerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  linkComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType])
};